import {gql} from '@apollo/client';

export const EXPORT_SORTER_PLAN_CHUTES = gql`
    mutation ExportSorterPlanChutes($sorterPlanId: Long!, $language: String!) {
        exportSorterPlanChutes(sorterPlanId: $sorterPlanId, language: $language)
    }
`;

